import { render, staticRenderFns } from "./PolicyUsersCompetitions.vue?vue&type=template&id=b0b7f588"
import script from "./PolicyUsersCompetitions.vue?vue&type=script&lang=js"
export * from "./PolicyUsersCompetitions.vue?vue&type=script&lang=js"
import style0 from "./PolicyUsersCompetitions.vue?vue&type=style&index=0&id=b0b7f588&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports